import '../Header/Header.css';
// import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
// import logo from "../../assets/images/TR-logo.png";
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import { useAuth } from '../security/authContext';
import React, { useEffect, useState } from "react";
import { LuLogOut, LuAlignJustify } from "react-icons/lu";
import { RxCross1 } from "react-icons/rx";
import logo from "../../assets/images/logo-mini.png";

const Header = ({ onToggleSidebar, isMobile, collapsed }) => {
  const [utcTime, setUtcTime] = useState("");
     const { logout } = useAuth();

     const logoutFn = () => {
          logout();
     }
     // UTC Time & Date
     const updateClock = () => {
        const now = new Date();
        const day = now.getUTCDate();
        const month = now.getUTCMonth() + 1;

        const hours = String(now.getUTCHours()).padStart(2, "0");
        const minutes = String(now.getUTCMinutes()).padStart(2, "0");
     //    const seconds = String(now.getUTCSeconds()).padStart(2, "0");
        setUtcTime(`UTC: ${day}/${month} ${hours}:${minutes}`);
     }

      useEffect(()=> {
          updateClock();

          const interval = setInterval(() => {
               updateClock();
          }, 1000);
          return () => clearInterval(interval);
      }, []);

     return (
          <Navbar className='' fixed="top">
               <div className='logo' style={{ display: isMobile ? 'block' : 'none'}}> <Link to="/dashboard"><img src= {logo} style={{width:'40px' }} /> </Link></div>
               <div className='d-flex align-items-center'>
               <NavDropdown title={localStorage.getItem("username")} id="navbarScrollingDropdown" className='dropDownNav' style={{marginBottom:"0px"}}>
                    <NavDropdown.Item onClick={logoutFn}>
                          <LuLogOut /> Log Out
                    </NavDropdown.Item>
               </NavDropdown>
               <span style={{fontSize:"12px", margin:"4px 9px 0"}}>{utcTime}</span>
               <button onClick={onToggleSidebar} className="btn" style={{fontSize:"20px", lineHeight:"22px", border: "2px solid #3167f3", borderRadius:"5px", padding:"2px 6px", margin: "0 10px"}}>
                    { !isMobile || collapsed ? ( <LuAlignJustify style={{color:"#3167f3"}}/> ) :  ( <RxCross1 style={{color:"#3167f3"}}/> ) }
               </button>
               </div>
          </Navbar>
     )
}

export default Header;